import { Outlet } from "react-router-dom"
import Menu from "../Menu/Menu"
import menuConfig from '../../config/adminMenu.json'

const AdminLayout = () => {
  return <div>
    <Menu
      config={menuConfig}
    />
    <Outlet></Outlet>
  </div>
}
export default AdminLayout